import { get } from "../../api";

const getFilters = () => get("filter");

const autoSuggestConfig = () => get("configAutoSuggestion");

export {getFilters, autoSuggestConfig};

